import { Injectable } from '@angular/core';
import { ProjectsService } from './projects.service';
import { AuthService, RouteService as MenuService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class RoutesService {
  private menu: any = [];

  constructor(private readonly projectsService: ProjectsService, private readonly menuService: MenuService, private readonly authService: AuthService) {
    this.menuService.get().subscribe(_ => this.menu = _);
    this.projectsService.getProjects().subscribe(_ => {
      var projects: any[] = [];

      // SEARCH
      if (_.some((p: any) => p.userRoles && (p.userRoles.includes('certifier') || p.userRoles.includes('issue manager')))) {
        if (!this.menu.some((route: any) => route.path == 'search')) {
          this.menuService.add(
            {
              path: '/search',
              title: 'Search',
              icon: 'search',
              class: '',
              groupTitle: false,
              submenu: []
            });
        }
      }
      // REPORTS
      if (_.some((p: any) => p.userRoles && (p.userRoles.includes('reporting')))) {
        if (!this.menu.some((route: any) => route.path == 'reports')) {
          this.menuService.add({
            path: 'reports',
            title: 'Reports',
            icon: 'file',
            class: 'menu-toggle',
            groupTitle: false,
            submenu: []
          });
          this.menuService.add({
            parentPath: 'reports',
            path: '/reports/email-list',
            title: 'Email List',
            icon: 'email',
            class: '',
            groupTitle: false,
            submenu: []
          });
          this.menuService.add({
            parentPath: 'reports',
            path: '/reports/project-results',
            title: 'Project Results',
            icon: 'collections',
            class: '',
            groupTitle: false,
            submenu: []
          });
          this.menuService.add({
            parentPath: 'reports',
            path: '/reports/user-results',
            title: 'User Results',
            icon: 'users',
            class: '',
            groupTitle: false,
            submenu: []
          });
        }
      }
      // ADMIN
      this.authService.userInfo().subscribe(_ => {
        if (_.isAdmin) {
          if (!this.menu.some((route: any) => route.path == 'admin')) {
            this.menuService.add({
              path: 'admin',
              title: 'Administration',
              icon: 'users',
              class: 'menu-toggle',
              groupTitle: false,
              submenu: [
                {
                  path: '/admin/email-users',
                  title: 'Email Users',
                  icon: 'users',
                  class: '',
                  groupTitle: false,
                  submenu: []
                }
              ]
            });
          }
        }
        // VERSIVO ADMIN
        if (_.isAdmin && _.isVersivoEmployee) {
          if (!this.menu.some((route: any) => route.path == 'versivo')) {
            this.menuService.add({
              path: 'versivo',
              title: 'Versivo Admin',
              icon: 'settings',
              class: 'menu-toggle',
              groupTitle: false,
              submenu: [
                {
                  path: '/admin/users',
                  title: 'Users',
                  icon: 'users',
                  class: '',
                  groupTitle: false,
                  submenu: []
                },
                {
                  path: '/admin/documents',
                  title: 'Documents',
                  icon: 'filter',
                  class: '',
                  groupTitle: false,
                  submenu: []
                },
                {
                  path: '/admin/projects',
                  title: 'Projects',
                  icon: 'folder',
                  class: '',
                  groupTitle: false,
                  submenu: []
                },
                {
                  path: '/admin/messages',
                  title: 'Messages',
                  icon: 'folder',
                  class: '',
                  groupTitle: false,
                  submenu: []
                }
              ]
            });
          }
        }
      });
    });

  }

  
}
